export const AUTH_LOCALSTORAGE_KEY = 'AUTH';

/* eslint-disable no-control-regex */
export const AuthMethod = {
  EMAIL: 'email',
  FACEBOOK: 'fb',
  OAUTH: 'oauth',
};
// eslint-disable-next-line -- intentionally naming the object the same as the type
export type AuthMethod = typeof AuthMethod[keyof typeof AuthMethod];

export const AuthType = {
  LOGIN: 'login',
  REGISTER: 'register',
  SWEEPS: 'sweeps'
};

// eslint-disable-next-line -- intentionally naming the object the same as the type
export type AuthType = typeof AuthType[keyof typeof AuthType];